<template>
    <div class="col-12 col-lg-12 order-1 order-md-1 order-lg-1 mb-4">
        <!-- Tabel Sarana -->
        <div class="card">
            <div class="card-header">
                <div class="col-12 col-lg-12">
                    <div class="row">
                        <div class="col-6 col-lg-6 order-1 order-lg-1">
                            <h5
                                style="
                                    vertical-align: middle !important;
                                    float: left !important;
                                "
                            >
                                Master List (P2h)
                            </h5>
                        </div>
                        <div class="col-6 col-lg-6 order-2 order-lg-2">
                            <div class="col-12 col-lg-12">
                                <div class="d-flex justify-content-end">
                                    <button
                                        class="btn btn-sm btn-primary me-2"
                                        type="button"
                                        @click="inputFocusEvent"
                                    >
                                        <span class="tf-icons bx bx-plus"></span
                                        >&nbsp; Tambah List
                                    </button>
                                    <button
                                        ref="updateBtn"
                                        id="showToastPlacement"
                                        class="btn btn-sm btn-warning"
                                        type="button"
                                        @click="getP2hList(halaman)"
                                    >
                                        <span
                                            class="tf-icons bx bx-refresh"
                                        ></span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="table-responsive text-nowrap">
                <table class="table table-hover">
                    <caption class="ms-4" v-if="p2h.total > 0">
                        <span
                            >Showing
                            {{ p2h.from }}
                            to
                            {{ p2h.to }}
                            of
                            {{ p2h.total }}&nbsp;
                        </span>
                        <span> List Master List (P2h)</span>
                    </caption>
                    <thead>
                        <tr>
                            <th style="width: 10%">NOMOR</th>
                            <th colspan="2">ITEM</th>
                            <th
                                colspan="2"
                                style="width: 20%; text-align: center"
                            >
                                AKSI
                            </th>
                        </tr>
                    </thead>
                    <tfoot>
                        <tr>
                            <th>NOMOR</th>
                            <th colspan="2">ITEM</th>
                            <th colspan="2" style="text-align: center">AKSI</th>
                        </tr>
                    </tfoot>
                    <tbody class="table-border-bottom-0">
                        <tr v-for="(a, b) in p2h.data">
                            <td>
                                <i
                                    class="fab fa-angular fa-lg text-danger me-3"
                                ></i>
                                <strong>{{ p2h.from + b }}</strong>
                            </td>
                            <td>{{ a.itemList }}</td>
                            <td>
                                <table
                                    v-if="a.p2h_item.length > 0"
                                    class="table table-bordered"
                                >
                                    <thead>
                                        <tr>
                                            <th colspan="2">SUB ITEM</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(c, d) in a.p2h_item">
                                            <td>{{ c.itemSub }}</td>
                                            <td style="text-align: center">
                                                <div class="dropdown">
                                                    <button
                                                        type="button"
                                                        class="btn p-0 dropdown-toggle hide-arrow"
                                                        data-bs-toggle="dropdown"
                                                    >
                                                        <i
                                                            class="bx bx-dots-vertical-rounded"
                                                        ></i>
                                                    </button>
                                                    <div class="dropdown-menu">
                                                        <button
                                                            class="dropdown-item"
                                                            @click="
                                                                editItems(
                                                                    a.idP2hList,
                                                                    a.itemList,
                                                                    c
                                                                )
                                                            "
                                                        >
                                                            <i
                                                                class="bx bx-edit-alt me-1"
                                                            ></i>
                                                            Edit
                                                        </button>
                                                        <button
                                                            class="dropdown-item"
                                                            @click="
                                                                delItems(
                                                                    c.idP2hItem
                                                                )
                                                            "
                                                        >
                                                            <i
                                                                class="bx bx-trash me-1"
                                                            ></i>
                                                            Delete
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>

                            <td style="text-align: center">
                                <span
                                    :class="
                                        a.statusList
                                            ? 'badge me-1 bg-label-success'
                                            : 'badge me-1 bg-label-danger'
                                    "
                                    >{{
                                        a.statusList == 1
                                            ? "Active"
                                            : "Non-Active"
                                    }}</span
                                >
                            </td>
                            <td style="text-align: center">
                                <div class="dropdown">
                                    <button
                                        type="button"
                                        class="btn p-0 dropdown-toggle hide-arrow"
                                        data-bs-toggle="dropdown"
                                    >
                                        <i
                                            class="bx bx-dots-vertical-rounded"
                                        ></i>
                                    </button>
                                    <div class="dropdown-menu">
                                        <button
                                            class="dropdown-item"
                                            @click="edit(a.idP2hList)"
                                        >
                                            <i class="bx bx-edit-alt me-1"></i>
                                            Edit
                                        </button>
                                        <button
                                            class="dropdown-item"
                                            @click="
                                                addItem(a.idP2hList, a.itemList)
                                            "
                                        >
                                            <i class="bx bx-plus me-1"></i>
                                            Add Item
                                        </button>
                                        <button
                                            class="dropdown-item"
                                            @click="del(a.idP2hList)"
                                        >
                                            <i class="bx bx-trash me-1"></i>
                                            Delete
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="p2h.total == 0">
                            <td>Tidak Ada Data</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <Bootstrap5Pagination
                    :data="p2h"
                    @pagination-change-page="getP2hList"
                />
            </div>
        </div>
        <!--/ Hoverable Table rows -->
        <!-- Form Sarana -->
        <master-p2h-form
            @tabelP2hEmit="doEmits"
            ref="focusRef"
            :tokens="tokens"
        ></master-p2h-form>

        <master-p2h-item-form
            @tabelP2hEmit="doEmits"
            ref="focusFormRef"
            :tokens="tokens"
        ></master-p2h-item-form>
    </div>
</template>

<script>
import axios from "axios";
import { Bootstrap5Pagination } from "laravel-vue-pagination";
import MasterP2hForm from "./form/masterp2h.vue";
import { ref } from "vue";
const focusRef = ref(null);
const focusFormRef = ref(null);

export default {
    components: {
        Bootstrap5Pagination,
        MasterP2hForm,
    },
    mounted() {
        this.csrfTokens = this.tokens;
        this.getP2hList(this.halaman);
        var thisFocus = this;
        var myOffcanvas = document.getElementById("offcanvasBoth");
        var masterItemCanvas = document.getElementById("masterItemP2hCanvas");

        myOffcanvas.addEventListener("shown.bs.offcanvas", () => {
            thisFocus.$refs.focusRef.focusInputs();
        });
        masterItemCanvas.addEventListener("shown.bs.offcanvas", () => {
            thisFocus.$refs.focusFormRef.focusItemInputs();
        });
    },
    data() {
        return {
            p2h: {},
            halaman: 1,
            csrfTokens: "",
        };
    },
    props: ["tokens"],
    methods: {
        toast() {
            $("#myToast").toast("show");
        },
        getP2hList(page) {
            if (page != undefined) {
                this.halaman = page;
            }
            axios
                .get("/sarana/masterp2h/create?page=" + this.halaman)
                .then((response) => {
                    var p2h = response.data;
                    if (p2h != null) {
                        this.p2h = p2h;
                    }
                });
        },
        del(idP2hList) {
            axios.delete("/sarana/masterp2h/" + idP2hList).then((response) => {
                if (response != null) {
                    this.p2h = {};
                    this.getP2hList(this.halaman);
                }
            });
        },
        delItems(id) {
            axios.delete("/sarana/masteritemp2h/" + id).then((response) => {
                if (response != null) {
                    this.p2h = {};
                    this.getP2hList(this.halaman);
                }
            });
        },
        doEmits() {
            this.getP2hList(this.halaman);
        },
        inputFocusEvent() {
            var thisFocus = this;
            var myOffcanvas = document.getElementById("offcanvasBoth");
            thisFocus.$refs.focusRef.initDatas();
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);

            bsOffcanvas.toggle();
        },
        edit(id) {
            var thisFocus = this;
            var myOffcanvas = document.getElementById("offcanvasBoth");
            thisFocus.$refs.focusRef.getByIds(id);
            var bsOffcanvas = new bootstrap.Offcanvas(myOffcanvas);
            bsOffcanvas.toggle();
        },
        addItem(id, named) {
            var thisFocus = this;
            var itemCanvas = document.getElementById("masterItemP2hCanvas");
            thisFocus.$refs.focusFormRef.setIdList(id, named);

            var bsOffcanvas = new bootstrap.Offcanvas(itemCanvas);
            bsOffcanvas.toggle();
        },
        editItems(id, named, c) {
            var thisFocus = this;
            var itemCanvas = document.getElementById("masterItemP2hCanvas");
            thisFocus.$refs.focusFormRef.setEditIdList(id, named, c);

            var bsOffcanvas = new bootstrap.Offcanvas(itemCanvas);
            bsOffcanvas.toggle();
        },
    },
};
</script>
